import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import D0101Demo from '@/components/functions/D0101Demo/D0101DemoStore'
import M0001User from '@/components/functions/M0001User/M0001UserStore'
import M0002SNSLink from '@/components/functions/M0002SNSLink/M0002SNSLinkStore'
import M0005ScheduleList from '@/components/functions/M0005ScheduleList/M0005ScheduleListStore'
import M0006SNSReport from '@/components/functions/M0006SNSReport/M0006SNSReportStore'
import M0007SNSPostComments from '@/components/functions/M0007SNSPostComments/M0007SNSPostCommentsStore'
import TestPublish from '@/components/functions/TestPublish/TestPublishStore'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

Vue.use(Vuex)
Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)

export default new Vuex.Store({
  modules: {
    Auth,
    D0101Demo,
    M0001User,
    M0002SNSLink,
    M0005ScheduleList,
    M0006SNSReport,
    M0007SNSPostComments,
    TestPublish,
    Calendar,
    DatePicker
  }
})
